import { useSelector } from 'react-redux';
import { validateInvestorApplication } from 'utils/investorApplicationValidation';

export function useInvestorApplicationValidation() {
  // TODO: See if user is needed
  const user = useSelector(state => state.user)
  const formState = useSelector(state => state.forms)
  const { isValidCarrierUsers } = useCarrierUsersValidation();

  const validation = validateInvestorApplication({ user, formState, isValidCarrierUsers})
  const logValidation = () => { 
    console.log("Investor application validation:", validation)
  }

  return { isValid: validation.valid, logValidation }
}

export function useCarrierUsersValidation() {
  const formState = useSelector(state => state.forms);

  const users = formState?.carrier?.carrierUsers || [];

  const vatList = users.map(user => user?.shareholderVat).filter(Boolean);
  const hasDuplicateVat = new Set(vatList).size !== vatList.length;

  const nameList = users.map(user => user?.shareholderName).filter(Boolean);
  const hasDuplicateName = new Set(nameList).size !== nameList.length;

  const percentageSum = users.reduce((sum, user) => {
    const perc = parseFloat((user?.shareholderPercentage)?.replaceAll(',','.')) || 0;
    return sum + perc;
  }, 0);

  const percentageSumIsValid = percentageSum <= 100;

  const isValidCarrierUsers = !hasDuplicateVat && !hasDuplicateName && percentageSumIsValid;

  return { isValidCarrierUsers };
}
